import { useState } from "react"
import { useDispatch } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import * as userSlice from "../store/user"
import * as userApis from "../utilities/apis/user"
import GuestLayout from "../components/GuestLayout"

const NotFound = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    try {
      setLoading(true)
      e.preventDefault()

      const form = new FormData(e.target)
      const username = form.get("username")
      const password = form.get("password")

      if (!username) throw new Error("Username is required")
      if (!password) throw new Error("Password is required")

      const response = await userApis.login({ username, password })
      if (!response.status) throw new Error(response.message)

      dispatch(userSlice.login(response))
      navigate("/dashboard")
    } catch (error) {
      alert(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <GuestLayout
      header={true}
      footer={false}
    >
      <main className="w-75 mx-auto">
        <div id="login" className="row">
          <div className="col-md-3"></div>
          <div className="col-md-6">
            <div className="card rounded-4 shadow-none">
              <div className="card-body p-5 text-center">
                <h3 className="text-body-emphasis fw-bold">404</h3>
                <p className="lead text-body-secondary fw-bold">Not Found</p>
                <p className="fw-semibold text-body-tertiary">The page you are looking for is either moved or removed</p>
                <Link className="btn btn-theme w-25">Home</Link>
              </div>
            </div>
          </div>
          <div className="col-md-3"></div>
        </div>
      </main>
    </GuestLayout>
  )
}

export default NotFound